import HttpServices from './HttpServices';

interface HttpService {
	post: (url: string, data: any, successCallback: (response: any) => void, errorCallback: (error: any) => void) => void;
}

interface AuthService {
	getAccessToken: () => string | null;
}

export default class ShopifyManualSortingServices {
	private HttpServices: HttpServices;
	private BO_API_URL: string;

	private config: { headers: { Authorization?: string } };
	private accountId: string;

	private serviceCache;
	private setServiceCache: React.Dispatch<React.SetStateAction<any>>;

	private useMock: boolean; 

	constructor($http: HttpService, authServices: AuthService, accountId: string, serviceCache, setServiceCache: React.Dispatch<React.SetStateAction<any>>) {
		this.HttpServices = new HttpServices($http);

		if (!(window as any) || !(window as any).BEYABLE_env || !(window as any).BEYABLE_env.BO_API_URL) {
			throw new Error('Configuration [window.BEYABLE_env.BO_API_URL] missing');
		} else {
			this.BO_API_URL = `${(window as any).BEYABLE_env.BO_API_URL}`;
		}

		const token = authServices && authServices.getAccessToken();
		this.config = { headers: {} };

		if (token) {
			this.config.headers.Authorization = 'Bearer ' + token;
		}

		this.accountId = accountId;

		this.serviceCache = serviceCache;
		this.setServiceCache = setServiceCache;

		this.useMock = false;
	}

	canUseShopifyManualSorting(
		callbackSuccess: ((canUse: boolean) => void),
		callbackError: ((error: string) => void)): void {
	
		if (this.serviceCache.canUseShopifyManualSorting !== undefined) {
			callbackSuccess(this.serviceCache.canUseShopifyManualSorting);
			return;
		}

		if (this.useMock) {
			this.setServiceCache(c => ({ ...c, canUseShopifyManualSorting: true }));
			callbackSuccess(true);
			return;
		}

		this.HttpServices.get(`${this.BO_API_URL}${this.accountId}/shopify-product-ranking-configuration`, (data: ShopifyRankingConfiguration) => {
			this.setServiceCache(c => ({ ...c, canUseShopifyManualSorting: data.canPinProducts }));
			callbackSuccess(data.canPinProducts);
		}, callbackError);
	}

	getAvailableShopifyCollectionInfos(
		callbackSuccess: ((shopifyProductCollections: ShopifyProductCollection[]) => void),
		callbackError: ((error: string) => void)): void {
		if (this.serviceCache.shopifyProductCollections !== undefined) {
			callbackSuccess(this.serviceCache.shopifyProductCollections);
			return;
		}
		this.HttpServices.get(`${this.BO_API_URL}${this.accountId}/shopify-collection-product-ranking/collections`, (data: ShopifyProductCollection[]) => {
			this.setServiceCache(c => ({ ...c, shopifyProductCollections: data }));
			callbackSuccess(data);
		}, callbackError);
	}

	getShopifyCollectionProductsManualPositions(
		callbackSuccess: ((shopifyManualProductPositions: ShopifyCollectionManualProductPosition[]) => void),
		callbackError: ((error: string) => void)): void {
		this.HttpServices.get(`${this.BO_API_URL}${this.accountId}/shopify-product-ranking-manual-position`, callbackSuccess, callbackError);
	}
}

export type ShopifyManualProductPosition = {
	productId: string;
	position: number;
}


export type ShopifyProductCollection = {
	id: string;
	title: string;
	handle: string
}

export type ShopifyCollectionManualProductPosition = {
	collectionId: string;
	productPositions: ShopifyManualProductPosition[]
}


type ShopifyRankingConfiguration = {
	canPinProducts: boolean 
}